import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useKeycloak } from '@react-keycloak/web'

import { AppAuthProvider } from 'src/middleware'
import Loader from 'src/components/shared/loader'

const LoginPage: React.FC = () => {
    const navigate = useNavigate();
    const { authProvider } = AppAuthProvider()
    const { keycloak, initialized } = useKeycloak()

    React.useEffect(() => {
        if (initialized && keycloak.authenticated) {
            navigate('/');
        }
    }, [initialized, keycloak.authenticated, navigate]);

    return (
        <div className="h-screen w-full bg-white flex justify-center items-center">
            {!initialized ? <Loader/>:
                <div>
                    {!keycloak.authenticated && (
                        <button type="button" className='h-8 rounded-md text-sm w-28 bg-blue-950 text-white hover:bg-blue-900'
                            onClick={() => authProvider.login()}>
                            Login
                        </button>
                    )}
                </div>}
        </div>
    )
}

export default LoginPage
